module.exports = __webpack_public_path__ + "img/banner-pattern.34526696.svg";